<template>
    <div class="hero-foot">
        <div class="container has-text-centered">
            <p class="has-text-grey-light" style="margin-bottom: 25px;">
                scroll down to learn more
            </p>
        </div>
    </div>
    <!-- Creating cool non-regular section transitions -->
    <!-- Using CSS and SVGs -->
    <!-- https://css-tricks.com/creating-non-rectangular-headers/ -->
</template>

<script>
export default {
  name: 'Foot',
};
</script>

<style lang="scss">
</style>
